const getCourses = state => state.courses
const getCoursesHome = state => state.courses_home
const getCourse = state => state.course
const getReviews = state => state.reviews
const getLesson = state => state.lesson
const getCertificatedCourses = state => state.certificatedCourses
const getQuiz = state => state.quiz
const getQuizHeader = state => state.quizHeader
const getQuizInfo = state => state.quizInfo
const getSubmitQuiz = state => state.submitQuiz

export default {
    getCourses,
    getCoursesHome,
    getCourse,
    getReviews,
    getLesson,
    getQuiz,
    getQuizHeader,
    getCertificatedCourses,
    getQuizInfo,
    getSubmitQuiz,
}